import { render, staticRenderFns } from "./SendVerificationCode.vue?vue&type=template&id=ab880f50&scoped=true&"
import script from "./SendVerificationCode.vue?vue&type=script&lang=ts&"
export * from "./SendVerificationCode.vue?vue&type=script&lang=ts&"
import style0 from "./SendVerificationCode.vue?vue&type=style&index=0&id=ab880f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab880f50",
  null
  
)

export default component.exports